import { render, staticRenderFns } from "./FormGroup.vue?vue&type=template&id=05c1be09&scoped=true"
import script from "./FormGroup.vue?vue&type=script&lang=js"
export * from "./FormGroup.vue?vue&type=script&lang=js"
import style0 from "./FormGroup.vue?vue&type=style&index=0&id=05c1be09&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c1be09",
  null
  
)

export default component.exports